<div class="bg-white border m-2 py-3 px-3 shadow-sm">
  <h5>{{ title() }}</h5>
  @if (mode() === 'unavailable') {
    <p class="mb-2"><span class="text-danger">Warning:</span> Marking a device as unavailable will take it out of single
      app mode,
      so it can be diagnosed. Make sure the device is not in a guest room.<br />
      This action should only be performed when the device is malfunctioning.</p>
  }
  @if (mode() === 'unassign') {
    <p class="mb-2"><span class="text-warning text-bold">Remark:</span> When the device is unassigned all location and
      room based
      settings will be removed. The device should not be in a room anymore.</p>
  }
  @if (mode() === 'spare') {
    <p class="mb-2"><span class="text-danger">Warning:</span> Marking this device as spare will remove the ability to
      control the
      room with the app and will show the setup app. When doing this the device should not be in a room anymore.</p>
  }
  @if (showChildCategorySelector()) {
    <era-device-link-selector [locations]="locations()"
                              [childCategories]="children()"
                              [selection]="selection()"
                              [spareOnly]="mode() === 'spare'"
                              (selectionChange)="updateSelection($event)" />
  }
  <button type="button"
          class="btn me-2"
          [class.btn-success]="showChildCategorySelector()"
          [class.btn-warning]="mode() === 'unassign'"
          [class.btn-danger]="mode() === 'unavailable'"
          id="device-assign-assign-button"
          [disabled]="!isValidSelection()"
          (click)="markAsCategory()">{{ mode() === 'unavailable' ? 'Confirm' : title() }}</button>
  <a class="btn btn-outline-primary"
     id="device-assign-cancel-button"
     [routerLink]="['../']">Cancel</a>
</div>